import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppConstant } from '../common/app.constant';
import { IAuthorityHistoryCommonChange } from '../models/authority-history-common.interface';
import { AuthorityHistoryColumnName } from '../models/authority-history-coulmn-name.interface';
import { IAuthorityHistoryModel } from '../models/authority-history.interface';
import { IAuthorityModificationDisplay } from '../models/authority-modification-display.interface';
import { ITrackAuthority, TrackAuthority } from '../models/trackauthority';
import { DataShareService } from '../services/data-share.service';
import { EventBusService, EventType } from '../services/eventbus.service';
import { Location } from '@angular/common';
import { Status } from '../models/status.enum';
import { ProxyUser } from '../models/proxyuser';
import { User } from '@csx/security';
import { PollService } from '../services/poll.service';
import { EICSTatus } from '../models/eic-status.enum';

@Component({
  selector: 'auth-history',
  templateUrl: 'change-history.component.html',
  styleUrls: ['./change-history.component.scss']
})
export class ChangeHistoryComponent implements OnInit, OnDestroy {
  Status = Status;
  eicStatus = EICSTatus;
  public title = AppConstant.CHANGE_HISTORY_TITLE;
  public showHistory = false;
  public blocked = true;
  public authorityHistories: IAuthorityModificationDisplay[] = [];
  public isAuthorityHistory: boolean;
  public selectedAuthority: ITrackAuthority;
  public newAuthority: TrackAuthority;
  public columnNames: AuthorityHistoryColumnName[] = [];
  public authorityHistoryCount = 0;
  public changeCount = 0;
  public initialAuthority;
  public sharedCount: number;
  private historyDataShareSubscription: Subscription;
  private authorityUpdateSubscription: Subscription;
  constructor(private dataShareService: DataShareService, private eventBus: EventBusService, private _location: Location, private user: User, private proxy: ProxyUser, private pollService:PollService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.sharedCount = 0;
    this.columnNames = AppConstant.AUTHORITY_HISTORY_COLUMN_NAMES;
    this.isAuthorityHistory = true;
    this.historyDataShareSubscription = this.dataShareService.authorityData.subscribe((authorityDetails: ITrackAuthority) =>
      this.fetchAuthority(authorityDetails)
    );
    this.authorityUpdateSubscription = this.eventBus.getEventBus(EventType.AUTHORITY_POLL_EVENT).subscribe(response => {
      this.updateCurrentAuthority(response.data as TrackAuthority[]);
    });
  }
  updateCurrentAuthority(response) {
    let updatedAuthority = response.filter(data => {
      return data.id === this.selectedAuthority.id;
    })[0];
    if (updatedAuthority) {
      this.fetchAuthority(updatedAuthority);
    }
  }

  fetchAuthority(authorityDetails: ITrackAuthority) {
    this.newAuthority = new TrackAuthority(authorityDetails, (this.proxy.racf || this.user.racf));
    this.sharedCount = this.newAuthority.activeSecondoriesCount;
    this.selectedAuthority = authorityDetails;
    let authorityHistoryModels = authorityDetails.trackAuthorityHistoryModels;
    this.authorityHistoryCount = authorityHistoryModels.length > 0 ? authorityHistoryModels.length - 1 : 0;
    if (authorityHistoryModels && authorityHistoryModels.length > 0) {
      this.changeCount = authorityHistoryModels.length;
      this.authorityHistories = [];
      authorityHistoryModels.map((authorityHistory: IAuthorityHistoryModel) => {
        this.authorityHistories.push({
          authorityHistoryChange: authorityHistory.authorityInfoChangeModels,
          authoritySnapshot: new TrackAuthority(authorityHistory.authoritySnapshot, (this.proxy.racf || this.user.racf)),
          authorityHistoryCommonChange: this.getAuthorityHistoryCommonChange(authorityHistory)
        });
      });
      this.initialAuthority = this.authorityHistories[this.authorityHistories.length - 1];
    }
    this.blocked = false;
  }

  private getAuthorityHistoryCommonChange(authorityHistory: IAuthorityHistoryModel) {
    let commonChangeData: IAuthorityHistoryCommonChange = {
      requestedById: authorityHistory.requestedById,
      changeTimeStamp: authorityHistory.changeTimeStamp,
      dispatcher: authorityHistory.dispatcher,
      requestedByName: authorityHistory.requestedByName,
      changeType: authorityHistory.changeType
    };
    return commonChangeData;
  }

  ngOnDestroy() {
    this.pollService.startPoll(30000);
    this.historyDataShareSubscription?.unsubscribe();
    this.authorityUpdateSubscription?.unsubscribe();
  }

  moveBack() {
    this._location.back();
  }
}
